import React, { useContext, useState } from "react";
import CategoryList from "./AllPosts/CategoryList";
import logo from "../Img/white logo-2.png";
import Viewer from "../Img/user_8777874.png";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import GlobalContext from "../context/GlobalContext";
import { useNavigate } from "react-router-dom";
import { IoPersonCircleSharp } from "react-icons/io5";

const HamburgerNavigation = () => {
  const { logoutModal, setLogoutModal, INHumberger, setINHumberger } =
    useContext(GlobalContext);

  const [isCollapse, setIsCollapse] = useState(false);
  const [selectIcon, setSelectIcon] = useState("right");
  const [isOpen, setIsOpen] = useState(true);

  const navigate = useNavigate();
  const rolles = localStorage.getItem("roles");

  const logOutBtn = () => {
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("tags");
    window.KR("remove");

    navigate("/");
  };

  const onclickHandler = () => {
    setINHumberger(false);
    // if (true){
    //   document.body.style.overflow = "hidden";
    //   setIsOpen(false)
    // }else{
    //   document.body.style.overflow = "";
    //   setIsOpen(true)
    // }
  };

  return (
    <nav className="navbar navbar-expand-lg bg-light navbar-light w-100 hamburger">
      <div className="container-fluid">
        <button
          onClick={onclickHandler}
          className="navbar-toggler "
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="user-det position-relative m-0">
          <div className="usr-bac">
            <IoPersonCircleSharp size={35} color="#000000" />
            <div className="user-name d-flex">
              <div>
                <p id="usrname">{localStorage.getItem("display_name")}</p>
                <p style={{ fontSize: "14px" }} id="usrrole">
                  {rolles == "administrator"
                    ? "Admin"
                    : rolles == "author"
                    ? "Author"
                    : "Viewer"}
                </p>
              </div>
              <div>
                {logoutModal ? (
                  <IoIosArrowUp
                    color="#000000"
                    role="button"
                    onClick={() => setLogoutModal(false)}
                  />
                ) : (
                  <IoIosArrowDown
                    role="button"
                    color="#000000"
                    onClick={(e) => {
                      e.stopPropagation();
                      setLogoutModal(true);
                    }}
                  />
                )}
              </div>
            </div>
          </div>
          {logoutModal && (
            <div
              className="p-2 position-absolute rounded text-center"
              style={{
                zIndex: "1",
                border: "1px solid",
                left: "45%",
                width: "60%",
                background: "white",
                cursor: "pointer",
              }}
            >
              <span className="text-danger" onClick={logOutBtn} role="button">
                Logout
              </span>
            </div>
          )}
        </div>

        <div
          className={
            INHumberger == undefined
              ? "collapse navbar-collapse flex-column"
              : INHumberger
              ? "collapse navbar-collapse bg-dark "
              : "collapse navbar-collapse bg-dark"
          }
          id="navbarNav"
          style={{ overflowY: "scroll" }}
        >
          <div
            style={{ paddingLeft: isCollapse ? "1.8rem" : "2rem" }}
            className="options pe-3 py-4 w-100"
          >
            {/* <GrGroup color='white' /> */}
            <CategoryList selectIcon={selectIcon} />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default HamburgerNavigation;
